import { BrowserModule } from '@angular/platform-browser';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MembersModule } from './members/members.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HttpClientService } from './services/httpClient.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { ToastrModule } from 'ngx-toastr';
import { DialogComponent } from './components/dialog/dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SearchComponent } from './components/search/search.component';
import { AreaModule } from './area/area.module';
import { SectorModule } from './sector/sector.module';
import { DrawerComponent } from './components/drawer/drawer.component';
import { GroupModule } from './group/group.module';
import { MatMenuModule } from '@angular/material/menu';
import { DirectsModule } from './directs/directs.module';
import { MatListModule } from '@angular/material/list';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { PatrimonyModule } from './patrimony/patrimony.module';
import { MaterialModule } from './material/material.module';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { FrequencyModule } from './frequency/frequency.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { LoaderComponent } from './components/loader/loader.component';
import { GroupWordModule } from './group-word/group-word.module';
import { AccountModule } from './account/account.module';
import { ModalComponent } from './components/modal/modal.component';
import { RouterModule } from '@angular/router';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { ChildrenModule } from './children/children.module';
import { NavigatorWithMenuComponent } from './components/navigator-with-menu/navigator-with-menu.component';
import { NavigatorComponent } from './components/navigator/navigator.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { ScrollComponent } from './scroll/scroll.component';
import { PagesModule } from './pages/pages.module';
import { OthersModule } from './others/others.module';
import { BannerModule } from './banner/banner.module';
import { PermissionsModule } from './permissions/permissions.module';

import { QuizModule } from './quiz/quiz.module';

registerLocaleData(ptBr);

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  declarations: [
    AppComponent,
    DialogComponent,
    DrawerComponent,
    LoaderComponent,
    ModalComponent,
    ToolbarComponent,
    NavigatorWithMenuComponent,
    NavigatorComponent,
    ScrollComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MembersModule,
    MatDividerModule,
    MatToolbarModule,
    HttpClientModule,
    MatSnackBarModule,
    MatIconModule,
    MatDialogModule,
    AreaModule,
    SectorModule,
    GroupModule,
    MatMenuModule,
    DirectsModule,
    MatListModule,
    IvyCarouselModule,
    PatrimonyModule,
    MaterialModule,
    CurrencyMaskModule,
    FrequencyModule,
    GroupWordModule,
    MatExpansionModule,
    RouterModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
    }),
    NgxMaskModule.forRoot(),
    AccountModule,
    ChildrenModule,
    PagesModule,
    OthersModule,
    AuthModule,
    BannerModule,
    PermissionsModule,
    AccountModule,
    QuizModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpClientService, multi: true },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    CurrencyPipe,
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
